<form name="log-package-auth-form" [formGroup]="PackageLoginForm" autocomplete="off">
  <app-modal-title>{{title}}</app-modal-title>
  <app-modal-body [height]="height" [minheight]="minheight">
    @if (error && !inProcess) {
    <div class="ot-row">
      <div class="ot-message ot-message--is-error w-100">
        <div class="ot-message__banner">
          <p id="login-error-text" class="ot-message__item">
            {{errorMsg}}
          </p>
        </div>
      </div>
    </div>
    }
    <div class="ot-m-1">
      <h5>{{description}}</h5>
      <div>
        <div class="ot-row">
          <div class="ot-row__column">
            <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : urlCtrl.invalid}">
              <label for="url" class="ot-form-control__label">
                <span i18n>URL</span>
              </label>
              <input #url formControlName="url" id="url" class="ot-input" type="text" placeholder="http://server:8080"
                readonly>
            </div>
          </div>
        </div>
        <div class="ot-row">
          <div class="ot-row__column ot-mr-1">
            <div class="ot-form-control">
              <label for="user" class="ot-form-control__label">
                <span class="ot-form-control--is-required">*</span>
                <span i18n>Username</span>
              </label>
              <input #user formControlName="user" id="user" class="ot-input" type="text">
            </div>
          </div>
          <div class="ot-row__column">
            <div class="ot-form-control">
              <label for="password" class="ot-form-control__label">
                <span class="ot-form-control--is-required">*</span>
                <span i18n>Password</span>
              </label>
              <input formControlName="password" id="password" class="ot-input" type="password" autocomplete="off">
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-modal-body>
  <app-modal-footer>
    <button class="ot-btn ot-btn--is-primary" type="submit" [disabled]="PackageLoginForm.invalid || inProcess"
      (click)="authenticate()">
      @if (!inProcess) {
      <span i18n-title title="Authenticate" i18n>Authenticate</span>
      }
      @if (inProcess) {
      <div class="ot-progress-container">
        <div class="ot-progress ot-progress--is-spinner">
          <div class="ot-progress__outer">
            <div class="ot-progress__meter auth-spinner"></div>
            <div class="ot-progress__text" i18n-title title="Authenticating..." i18n>Authenticating...</div>
          </div>
        </div>
      </div>
      }
    </button>
    <button class="ot-btn ot-btn--is-secondary" i18n-title title="Cancel" (click)="close()" i18n>
      Cancel
    </button>
  </app-modal-footer>
</form>